import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Navigate,
  Route
} from 'react-router-dom'
import { HomePage } from './components/HomePage/HomePage';
import { KategoriPage } from './components/KategoriPage/KategoriPage';
import { ChefListPage } from './components/ListChefPage/ChefListPage'
import { PageDetailChef } from './components/DetailChefPage/PageDetailChef';
import { PageDetailMenu } from './components/DetailMenuPage/PageDetailMenu';
import { PageSetSchedule } from './components/SetSchedulePage/pageSetSchedule';
import { PageSetVenue } from './components/SetVenuePage/PageSetVenue';
import { PageSubmitBooking } from './components/SubmitBookingPage/PageSubmitBooking';
import { PageReview } from './components/ReviewPage/PageReview';
import { PageMyBooking } from './components/MyBookingPage/PageMyBooking';
import { PageEvent } from './components/EventPage/PageEvent';
import { PageDetailEvent } from './components/DetailEventPage/PageDetailEvent';
import { PageSetEventSchedule } from './components/SetEventSchedulePage/PageSetEventSchedule';
import { PageSubmitBookingEvent } from './components/SubmitBookingEventPage/PageSubmitBookingEvent';
import { PageUserSettings } from './components/UserSettingsPage/PageUserSettings';
import { PageForgotPassword } from './components/ForgotPasswordPage/PageForgotPassword';
import { PageNotFound } from './components/404Page/PageNotFound';
import { getLoggedInStatus } from './utils/auth'

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/category" element={<KategoriPage/>}/>
          <Route path="/category/chefList" element={<ChefListPage/>}/>
          <Route path="/category/chefList/detailChef" element={<PageDetailChef/>}/>
          <Route path="/category/chefList/detailChef/detailMenu" element={<PageDetailMenu/>} />
          <Route path="/category/chefList/detailChef/detailMenu/setSchedule" element={<PageSetSchedule/>} />
          <Route path="/category/chefList/detailChef/detailMenu/setSchedule/setVenue" element={<PageSetVenue/>}/>
          <Route path="/category/chefList/detailChef/detailMenu/setSchedule/setVenue/submitBooking" element={<PageSubmitBooking/>}/>
          <Route path="/category/chefList/detailChef/detailMenu/setSchedule/setVenue/submitBooking/Review" element={<PageReview/>}/>
          <Route path="/MyBooking" element={<PageMyBooking/>}/>
          <Route path="/event" element={<PageEvent/>}/>
          <Route path="/forgotPassword" element={<PageForgotPassword/>}/>
          <Route path="/userSettings" element={
            getLoggedInStatus() ? <PageUserSettings/> : <Navigate to="/" />
          }/>
          <Route path="/event/detailEvent" element={<PageDetailEvent/>}/>
          <Route path="/event/detailEvent/setSchedule" element={<PageSetEventSchedule/>}/>
          <Route path="/event/detailEvent/setSchedule/submitBooking" element={<PageSubmitBookingEvent/>}/>
          <Route path="*" element={<PageNotFound/>}/>
        </Routes>
      </Router>
  );
}

export default App;
